import React, { Component } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Form from "antd/lib/form";
import Switch from "antd/lib/switch";
import Button from "antd/lib/button";
import Popover from "antd/lib/popover";
import Slider from "antd/lib/slider";
import { Row, Col } from "react-bootstrap";

class Pass extends Component {
  passColor(length) {
    if (length >= 12) {
      return "#bae637";
    }
    if (length >= 8 && length <= 11) {
      return "#ffa940";
    }
    if (length <= 7) {
      return "#ff4d4f";
    }
  }

  render() {
    const PopUp=(
        <p>Скопировать</p>
        );
    const {
      onChange,
      inputValue,
      pass,
      ChangeUppercase,
      ChangeLeters,
      ChangeSymbols,
      ChangeNumbers,
      leters,
      uppercase,
      numbers,
      symbols,
      ButtonClick
    } = this.props;
    const disabled = leters || uppercase || symbols || numbers;
    const color = this.passColor(pass.length);
    const StyleSpan = {
      fontSize: "2.5rem",
      borderBottom: `solid 1px ${color}`,
      marginBottom: "2rem"
    };
    return (
      <>
        <Row>
          <Col xs={12} style={StyleSpan} smHidden mdHidden lgHidden>
            <span>{pass}</span>
          </Col>
        </Row>
        <Row style={{ marginBottom: "2rem" }}>
          <Col xs={5} sm={5} md={4}>
            <Button type="primary" disabled={!disabled} onClick={ButtonClick}>
              Сгенерировать
            </Button>
          </Col>
          <Col xs={3} sm={3} md={1}>
            <CopyToClipboard text={pass}>
            <Popover content={PopUp} placement='right'>
              <Button
                type="primary"
                shape="circle"
                icon="copy"
                size="default"
              />
              </Popover>
            </CopyToClipboard>
          </Col>
        </Row>
        <Row>
          <Col sm={8}>
            <Form.Item label="Длина пароля">
              <Slider
                disabled={!disabled}
                min={3}
                max={24}
                onChange={onChange}
                label="E-mail"
                value={typeof inputValue === "number" ? inputValue : 0}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <Form.Item>
              <Switch
                checkedChildren="Строчные буквы"
                unCheckedChildren="Строчные буквы"
                defaultChecked={true}
                value={leters}
                onChange={ChangeLeters}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <Form.Item>
              <Switch
                checkedChildren="Прописные буквы"
                unCheckedChildren="Прописные буквы"
                defaultChecked={true}
                value={uppercase}
                onChange={ChangeUppercase}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <Form.Item>
              <Switch
                checkedChildren="Символы"
                unCheckedChildren="Символы"
                defaultChecked={false}
                value={symbols}
                onChange={ChangeSymbols}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col sm={6} xs={12}>
            <Form.Item>
              <Switch
                checkedChildren="Цифры"
                unCheckedChildren="Цифры"
                defaultChecked={false}
                value={numbers}
                onChange={ChangeNumbers}
              />
            </Form.Item>
          </Col>
        </Row>
      </>
    );
  }
}
export default Pass;
